import { render, staticRenderFns } from "./ScoreCardItemTotal.vue?vue&type=template&id=71c4a802&scoped=true&"
import script from "./ScoreCardItemTotal.vue?vue&type=script&lang=js&"
export * from "./ScoreCardItemTotal.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardItemTotal.vue?vue&type=style&index=0&id=71c4a802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4a802",
  null
  
)

export default component.exports